import { configureStore } from '@reduxjs/toolkit';
import youtubeReducer from './youtubeSlice';
import videoReducer from "./videoSlice";
import themeReducer from './themeSlice';

export const store = configureStore({
    reducer: {
        youtube: youtubeReducer,
        videos: videoReducer,
        theme: themeReducer,
    }
});